export enum NuclearGaugeStandardizationType {
  MoistureDensity = 1,
  ThinLift = 2,
  DualPurpose = 3,
}
export const moistureDensityHeader: Array<string> = [
  'Date',
  'Time',
  'Density last 4 Avg.',
  'Density Count',
  'Moisture Last 4 Avg.',
  'Moisture Count',
];
export const thinLiftHeader: Array<string> = [
  'Date',
  'Time',
  'System 1 last 4 Avg.',
  'System 1 Count',
  '',
  '',
  'System 2 Last 4 Avg.',
  'System 2 Count',
];
export const dualPurposeHeader: Array<string> = [
  'Date',
  'Time',
  'Density 1 last 4 Avg.',
  'Density 1 Count',
  '',
  '',
  'Density 2 Last 4 Avg.',
  'Density 2 Count',
  'Moisture last 4 Avg.',
  'Moisture Count',
];
export interface IStandardisationRecords {
  DensityCountInvalid: boolean;
  MoistureCountInvalid: boolean;
  DensityCountInvalid2: boolean;
  Locked: boolean;
  IsDeleted: boolean;
  DateTime: string;
}
